exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".green-filter[data-v-4e61b7e4]{align-items:center}", ""]);

// exports
